import React, { useState, useEffect, useMemo } from 'react';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';

function isUsableSchema(schema) {
  return schema && typeof schema === 'object' && Object.keys(schema).length > 0;
}

/**
 * Read-only RJSF preview for admin workflow editor (not tied to task draft/cache).
 */
export default function FormDefinitionPreview({ schema, uiSchema, defaults }) {
  const [localFormData, setLocalFormData] = useState(() => defaults || {});

  useEffect(() => {
    setLocalFormData(defaults || {});
  }, [schema, defaults]);

  const mergedUiSchema = useMemo(
    () => ({
      ...(uiSchema || {}),
      'ui:submitButtonOptions': {
        ...(uiSchema?.['ui:submitButtonOptions'] || {}),
        norender: true,
      },
    }),
    [uiSchema]
  );

  if (!isUsableSchema(schema)) {
    return (
      <div className="alert alert-warning mb-0 small" role="alert">
        No form schema available for preview.
      </div>
    );
  }

  return (
    <div className="rjsf-form border rounded p-2 bg-light">
      <Form
        schema={schema}
        uiSchema={mergedUiSchema}
        formData={localFormData}
        onChange={(e) => setLocalFormData(e.formData)}
        validator={validator}
        readonly
        showErrorList={false}
        noHtml5Validate
        liveValidate={false}
      />
    </div>
  );
}
